module.exports = __webpack_public_path__ + "1-08.png?b18268f81b457e2e1729072b5ebf9a0f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1-08.png
// module id = 85
// module chunks = 0